import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Checkbox = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, stroke, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill={color || 'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.25 7.75L7.25 9.75L11.25 5.75M4.5 2.5H11.5C12.6046 2.5 13.5 3.39543 13.5 4.5V11.5C13.5 12.6046 12.6046 13.5 11.5 13.5H4.5C3.39543 13.5 2.5 12.6046 2.5 11.5V4.5C2.5 3.39543 3.39543 2.5 4.5 2.5Z"
        stroke={stroke || 'currentColor'}
      />
    </svg>
  ),
)
Checkbox.displayName = 'Checkbox'

export default Checkbox
